import { useContext, createContext, useState } from "react";

import PropTypes from "prop-types";

import { sizeOptions } from "@/view/SecondaryActions/FontSizeAction/sizeOptions";

const propTypes = {
  children: PropTypes.node,
};

const AccessibilityControlsContext = createContext();

export const AccessibilityControlsContextProvider = ({ children }) => {
  const [showParagraphCount, setShowParagraphCount] = useState(false);
  const [currentFontSize, setCurrentFontSize] = useState(
    sizeOptions.small.size,
  );
  const currentFontSizeIndicator = sizeOptions[currentFontSize].indicator;

  return (
    <AccessibilityControlsContext.Provider
      value={{
        currentFontSize,
        currentFontSizeIndicator,
        setCurrentFontSize,
        setShowParagraphCount,
        showParagraphCount,
      }}
    >
      {children}
    </AccessibilityControlsContext.Provider>
  );
};

AccessibilityControlsContextProvider.propTypes = propTypes;

const useAccessibilityControlsContext = () => {
  const accessibilityControlsContext = useContext(AccessibilityControlsContext);

  if (accessibilityControlsContext === undefined) {
    throw new Error(
      "AccessibilityControlsContext must be used within a AccessibilityControlsContextProvider.",
    );
  }

  return accessibilityControlsContext;
};

export default useAccessibilityControlsContext;
